import { useEffect, useState } from 'react';

type UseOnMountCallback = () => void;

/**
 * Run a function once on mount
 * @param onMountCallback
 * @returns
 */
export const useOnMount = (onMountCallback?: UseOnMountCallback) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    if (!isMounted) {
      if (onMountCallback) {
        onMountCallback();
      }

      setIsMounted(true);
    }
  }, []);

  return {
    isMounted,
  };
};
